import React from 'react'

/** Decorative gradient waveform bars for track cards (no audio required). */
export default function WaveformPlaceholder({ className = '', barCount = 32, animate = true, height }) {
  const heights = React.useMemo(() => {
    const arr = []
    for (let i = 0; i < barCount; i++) {
      arr.push(20 + Math.random() * 80)
    }
    return arr
  }, [barCount])

  return (
    <div
      className={`flex items-center justify-center gap-0.5 ${className}`}
      style={height != null ? { height } : { height: 48 }}
      aria-hidden
    >
      {heights.map((h, i) => (
        <div
          key={i}
          className={`w-1 rounded-full bg-gradient-to-t from-[#00d4aa] via-[#14b8a6] to-[#5eead4] opacity-80 ${
            animate ? 'animate-pulse' : ''
          }`}
          style={{
            height: `${h}%`,
            animationDelay: `${(i % 5) * 0.1}s`,
          }}
        />
      ))}
    </div>
  )
}
